import React from 'react';
import { connect } from 'react-redux';
import './style.scoped.scss';
import Login from '../../components/Account/Login';
import { ROUTES } from '../../assets/constants/strings';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import { Redirect, useLocation } from 'react-router-dom';
import {
  isApiOnly,
  hasDeveloperApi,
  isSuperAdmin,
} from '../../services/entitlements';

const LoginPage = ({ user, loading }) => {
  // The URL decides the portal: logins reached from the developer-API funnel
  // carry ?portal=api and land on the API portal (when the account has access).
  const location = useLocation();
  const wantsApiPortal =
    new URLSearchParams(location.search).get('portal') === 'api';

  if (user && user.token && isSuperAdmin(user)) {
    // Internal SuperAdmin lands on the admin area.
    return <Redirect to={ROUTES.APIAdmin} />;
  } else if (user && user.token && isApiOnly(user)) {
    // API-only accounts always land on the developer portal.
    return <Redirect to={ROUTES.APIHOME} />;
  } else if (user && user.token && wantsApiPortal) {
    // Came through the API funnel: entitled accounts land on the portal,
    // others on the add-product page (activate the API on the SAME account).
    return (
      <Redirect
        to={hasDeveloperApi(user) ? ROUTES.APIHOME : ROUTES.APIACTIVATE}
      />
    );
  } else if (user && user.token && user.isActive) {
    return <Redirect to={ROUTES.HOME} />;
  } else if (user && user.token && !user.isActive) {
    return <Redirect to={ROUTES.SELECT_PLANS} />;
  }
  // if user is Admin 1WordFlow
  // else if (user?.isSuperAdmin) {
  //   return <Redirect to={ROUTES.HOME} />;
  // }
  // has not yet logged in
  else
    return (
      <AccountPagesWrapper>
        <div className='wf-account__card login'>
          <Login />
        </div>
      </AccountPagesWrapper>
    );
};

const mapStateToProps = (state) => ({
  userPlan: state.user.userPlan,
  user: state.user.user,
  loading: state.user.loading,
});


export default connect(mapStateToProps, {})(LoginPage);
